import img1 from '../assets/images/фото клиента1.png'
import img2 from '../assets/images/фото2.png'
import kunde1 from '../assets/images/kunde1.png'
import kunde2 from '../assets/images/kunde2.png'


const reviews = [
  {
    id: 1,
    text: 'Ich bin sehr zufrieden mit dem Kauf! Alles war ehrlich und transparent.',
    image: img1,
    name: 'Alex',
    stadt: 'Bielefeld'
  },
  {
    id: 2,
    text: 'Top Service – das Auto sieht aus wie neu!',
    image: img2,
    name: 'Marta',
    stadt: 'Hannover'
  },
  {
    id: 3,
    text: 'Johann hat alles erklärt, gezeigt und mir Zeit zum Überlegen gelassen – ganz ohne Druck. Bin sehr zufrieden mit dem Wagen!',
    image: kunde1,
    name: 'Abdula',
    stadt: 'Paderborn'
  },
  {
    id: 4,
    text: 'Toller Service! Papiere, Diagnose, Hilfe bei der Zulassung – alles bestens organisiert.',
    image: kunde2,
    name: 'Leo',
    stadt: 'Nürnberg'
  },
];
export default reviews;